export default __webpack_public_path__ + "static/home-background-sm-ad71a87070e7eb36dd00e3b2cfa1300a.jpg";